import React from 'react';
import { Section } from './Section';
import { AlertTriangleIcon } from 'lucide-react';
export function Problem() {
  return <Section bg="navy" data-id="element-182">
      <div className="max-w-3xl mx-auto bg-navy-light border border-red-900/30 rounded-xl md:rounded-2xl p-5 md:p-12 relative overflow-hidden" data-id="element-183">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-600/50 to-gold/50" data-id="element-184"></div>

        <div className="flex items-center gap-3 md:gap-4 mb-5 md:mb-8" data-id="element-185">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-red-900/20 flex items-center justify-center" data-id="element-186">
            <AlertTriangleIcon className="text-gold w-5 h-5 md:w-6 md:h-6" data-id="element-187" />
          </div>
          <h2 className="text-2xl md:text-4xl font-bold" data-id="element-188">
            El Verdadero Problema
          </h2>
        </div>

        <div className="space-y-4 md:space-y-6 text-base md:text-lg text-gray-light leading-relaxed" data-id="element-189">
          <p data-id="element-190">
            El problema no es que no ganes dinero. El problema es que el sistema
            financiero en México está diseñado para la supervivencia, no para el
            patrimonio.
          </p>
          <p data-id="element-191">
            Tu AFORE está topada y solo te entregará una fracción de lo que
            necesitas. Mientras tanto, la inflación educativa y el costo de vida
            siguen subiendo.
          </p>
          <p className="text-white font-medium p-4 md:p-6 bg-navy rounded-xl border border-white/5" data-id="element-192">
            Estás en la{' '}
            <span className="text-gold" data-id="element-193">"Trampa del Rango Medio"</span>: ganas
            demasiado para recibir ayuda, pero no tienes un blindaje que
            garantice que ese dinero regrese a ti pase lo que pase.
          </p>
        </div>
      </div>
    </Section>;
}